import { Types } from './actions';
import { INITIAL_STATE, STATUS } from './constants';
import { mergeReducers } from '~/store/utils';

const reducer = (state = INITIAL_STATE, action: any) => {
  switch (action.type) {
    case Types.REGISTRATION_REQUEST:
      return {
        status: STATUS.LOADING,
        error: null,
      };
    case Types.REGISTRATION_SUCCESS:
      return {
        status: STATUS.COMPLETE,
        error: null,
      };
    case Types.REGISTRATION_FAILURE:
    case Types.REGISTRATION_ERROR:
      return {
        status: STATUS.PROMPT,
        error: action.payload,
      };
    case Types.REGISTRATION_CLEAR:
      return INITIAL_STATE;
    default:
      return state;
  }
};

const confirmEmailReducer = (state = INITIAL_STATE, action: any) => {
  switch (action.type) {
    case Types.CONFIRM_EMAIL_REQUEST:
      return {
        status: STATUS.VERIFYING_EMAIL,
        error: null,
      };
    case Types.CONFIRM_EMAIL_SUCCESS:
      return {
        status: STATUS.VALID_TOKEN,
        error: null,
      };
    case Types.CONFIRM_EMAIL_FAILURE:
      return {
        status: STATUS.INVALID_TOKEN,
        error: action.payload,
      };
    case Types.CONFIRM_EMAIL_ERROR:
      return {
        status: STATUS.EXPIRED_TOKEN,
        error: action.payload,
      };
    case Types.CONFIRM_EMAIL_CLEAR:
      return INITIAL_STATE;
    default:
      return state;
  }
};

export default mergeReducers([reducer, confirmEmailReducer]);
